export default __webpack_public_path__ + "static/media/LGBHummingbirdGoesSideways640.92319866.jpg";